import FetchComponent from './components/FetchComponent';
import './App.css';

export default FetchComponent;



// WEBPACK FOOTER //
// ./src/App.js